import type { Registry as Services } from '@ember/service';
import dayjs from 'dayjs';

export default function hasUnseenInsights(
  smartInsights: Services['smart-insights'],
  isDrawerExpanded: boolean | null | undefined,
): boolean {
  if (
    !smartInsights.hasInsights ||
    smartInsights.hasDismissedNotificationBubble ||
    isDrawerExpanded
  ) {
    return false;
  }

  const hotelOrMarketId = smartInsights.localStorageHotelOrMarketId;
  const lastViewedDate = hotelOrMarketId
    ? smartInsights.getHasSeenDictFromLocalStorage()[hotelOrMarketId]
    : undefined;

  if (!lastViewedDate) {
    return true;
  }

  const lastViewedDay = dayjs(lastViewedDate).startOf('day');

  return (
    lastViewedDay.isValid() && lastViewedDay.isBefore(dayjs().startOf('day'))
  );
}
